import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BatchInfo from './BatchInfo';
import AccountList from './AccountList';
import { useDispatch, useSelector } from 'react-redux';
import { getDistricts, getStaffList } from '../../../actions/saActions';
import ListError from '../../../components/Common/ListError';
import { getAccountFilteredDistricts, getUserPreference } from '../../../utilities/common';
import { getSelectedBatchIdsSlot, showAlertSnackbar } from '../../../reducers/uiSlice';
import { getOrderFilter } from '../../../reducers/filterSlice';
import { LoadDispatchHistoryModalSlot } from './LoadDispatchHistoryModalSlot';
import _ from 'lodash';

const useStyles = makeStyles((theme)=> ({
    root: {
        height: '100vh',
        width: '100%'
    }
}))

function AccountListManagement(props) {
    const classes = useStyles();
    const dispatch = useDispatch();

    let orderFilters = useSelector(getOrderFilter);
    const slotManagement = useSelector(state => state.saReducer);
    let selectedBatchIds = useSelector(getSelectedBatchIdsSlot);

    const [enableManualEdit, setEnableManualEdit] = useState(true);
    const [manualEditLoading, setManualEditLoading] = useState(false);
    const [slotConfiguration, setSlotConfiguration] = useState([]);
    const [newSlotConfiguration, setNewSlotConfiguration] = useState([]);
    const [historyId, setHistoryId] = useState('');
    const [clear, setClear] = useState(false);
    const [existSlot, setExistSlot] = useState({});
    const [patternId, setPatternId] = useState(0);

    useEffect(() => {
        if(props.branch == null){
            console.error("[FATAL] City ID Missing!")
            dispatch(showAlertSnackbar({
                title: "[FATAL] City ID Missing!", 
                message: "Please contact administrator to sort out this problem! If it's resolved please login again!",
                duration: 15000
            }))
        }
        dispatch(getStaffList(props.branch, 1, patternId))
        dispatch(getDistricts());
        setExistSlot({});
    }, [props.branch, patternId])

    return (
        <div className={classes.root}>
            <LoadDispatchHistoryModalSlot
                branch={props.branch}
                dispatchHistoryList={slotManagement.getSortingHistoryList}
                isLoading={slotManagement.getSortingHistoryListLoading}
                handleManualLoadingDisable={handleManualLoadingDisable}
                setSlotConfigurationList={setSlotConfigurationList}
                saveHistoryId={saveHistoryId}
            />
            <div>
                <BatchInfo 
                    handlePatternId={handlePatternId}
                    branch={props.branch}
                    selectedBatchIds={selectedBatchIds}
                    handleEnableManualEdit={handleEnableManualEdit}
                    newSlotConfiguration={newSlotConfiguration}
                    historyId={historyId}
                    handleClear={handleClear}
                />  
            </div>       
        {slotManagement.staffError ? <ListError />: [
            <AccountList
                sectionLoading={slotManagement.ordersLoading}
                orderList={slotManagement.ordersByDriver}
                filter={orderFilters}
                data={getAccountFilteredDistricts(_.filter(slotManagement.staff, {'workingarea': 'A'}))}
                manualEdit={enableManualEdit}
                manualEditLoading={manualEditLoading}
                slotConfiguration={slotConfiguration}
                saveNewSlotConfiguration={saveNewSlotConfiguration}
                branch={props.branch}
                clear={clear}
                resetClear={resetClear}
                handleExistSlot={handleExistSlot}
                existSlot={existSlot}
            />
        ]}
        </div>
    );

    function saveHistoryId(id) {
        setHistoryId(id);
    }

    function saveNewSlotConfiguration(newSlotConfiguration) {
        setNewSlotConfiguration(newSlotConfiguration);
    }

    function setSlotConfigurationList(slot, type) {
        setSlotConfiguration(type === 'object' ? slot : slot.split("\,"));
    }

    function handleManualLoadingDisable(ifLoading) {
        setManualEditLoading(ifLoading);
    }

    function handleEnableManualEdit() {
        setEnableManualEdit(!enableManualEdit);
    }

    function handleClear() {
        setClear(true);
    }

    function resetClear() {
        setClear(false);
    }

    function handleExistSlot(id, slotNo, zone) {
        let existSlotCopy = existSlot;
        existSlotCopy[id] = {
            slotNo: slotNo,
            zone: zone
        };
        setExistSlot(existSlotCopy);
    }

    function handlePatternId(id) {
        setPatternId(id);
    }
}

export default AccountListManagement;